import type { Club } from "@repo/shared-types";

const clubRoleLabels: Record<string, string> = {
  OWNER: "Dueño",
  MANAGER: "Administrador",
  MEMBER: "Miembro",
};

/** The Spanish name of a club member's role; unknown roles show as they come. */
export const clubRoleLabel = (role: string) => clubRoleLabels[role] ?? role;

// The API answers a 403 by logging the user out, so owner-only actions must
// not even be offered to anyone else.
export const isClubOwner = ({ viewerRole }: Pick<Club, "viewerRole">) =>
  viewerRole === "OWNER" || viewerRole === "SUPER_ADMIN";

export const isClubOwnerOrManager = (club: Pick<Club, "viewerRole">) =>
  isClubOwner(club) || club.viewerRole === "MANAGER";
